var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "validationProvider",
    staticClass: "_eui-form_select_validation-provider",
    attrs: {
      tag: "div",
      mode: "eagerMedBlurOchDebounce",
      rules: _vm.vpValidationRules
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var valid = ref.valid
          var errors = ref.errors
          var failedRules = ref.failedRules
          var flags = ref.flags
          return [
            _c(
              "div",
              {
                staticClass: "_eui-form_select",
                class: [
                  _vm.vpClass,
                  {
                    "-obligatorisk":
                      _vm.arRequired && !_vm.vpIndikeraInteObligatorisk,
                    "-readonly": _vm.vpReadOnly,
                    "-osynlig": _vm.skaVaraOsynlig,
                    "-invalid": flags.validated && !valid
                  }
                ],
                style: _vm.vpStyle,
                attrs: { disabled: _vm.skaVaraInaktiverad }
              },
              [
                _c("label", {
                  staticClass: "_eui-form_select_etikett",
                  class: {
                    fore: true,
                    "-readonly": _vm.vpReadOnly
                  },
                  style: { "max-width": _vm.vpEtikettbreddMedEnhet },
                  attrs: { for: _vm.uniktId, title: _vm.vpTooltip },
                  domProps: { innerHTML: _vm._s(_vm.vpEtikett + ":") }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "_eui-form_select_rutyta",
                    style: { "max-width": _vm.vpRutbreddMedEnhet }
                  },
                  [
                    _c(
                      "select",
                      _vm._g(
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerValue,
                                expression: "innerValue"
                              }
                            ],
                            ref: "inputelementet",
                            class: {
                              "-readonly": _vm.vpReadOnly
                            },
                            attrs: {
                              id: _vm.uniktId,
                              name: _vm.uniktId + "-name",
                              required: !!_vm.vpPlaceholder && !_vm.vpReadOnly,
                              autofocus: _vm.vpAutofocus,
                              disabled: _vm.skaVaraInaktiverad || _vm.vpReadOnly
                            },
                            on: {
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.onEnterTryckt()
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.onEscTryckt()
                                }
                              ],
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.innerValue = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          "select",
                          _vm.$attrs,
                          false
                        ),
                        _vm.$listeners
                      ),
                      [
                        !!_vm.vpPlaceholder
                          ? _c("option", {
                              attrs: { value: "", disabled: "" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.vpReadOnly ? "" : _vm.vpPlaceholder
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.vpSelectConfig.alternativ, function(
                          alt,
                          altIndex
                        ) {
                          return _c("option", {
                            key: altIndex,
                            staticClass: "_eui-form_select-alt",
                            attrs: {
                              id: _vm.altUniktId(altIndex),
                              disabled:
                                alt.disabled ||
                                _vm.skaVaraInaktiverad ||
                                _vm.vpReadOnly
                            },
                            domProps: {
                              value: alt.varde,
                              selected: _vm.innerValue === alt.varde,
                              innerHTML: _vm._s(alt.text + "&nbsp;")
                            }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "_eui-form_select_feltext" }, [
                      _c("div", {
                        staticClass: "ellipsis",
                        domProps: { innerHTML: _vm._s(errors[0]) }
                      })
                    ])
                  ]
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }